// Increment when rendering logic, storage format, or cache key format changes to invalidate cached previews
export const RENDERER_VERSION = 6;
